/*
  KS Formatval – byte PDF/Tryckt utan omladdning (Kunskapstavlan, 2026-09-18)
  Hör till snippets/ks-format-picker.liquid. Egen kod, prefix ks-/ks-fp.

  Så fungerar det:
  - Andra formatets produkt hämtas i bakgrunden med Shopifys "section rendering"
    (samma mall via ?view=, samma sektion via ?section_id=), så allt renderas av temat självt.
  - Vid klick byts: formatkorten, prisblocket, rubrik/överrad, produkttext, leveransrader,
    lagerrad, köpknappens produkt och pris samt den flytande köpknappen. Adressen uppdateras.
  - Köpknappen skickar det valda formatets variant-ID till varukorgen via temats vanliga formulär.
  - Utan JavaScript, eller om hämtningen misslyckas, fungerar korten som vanliga länkar.
  - Om mallen har temats variantväljare används länkläge (sidan laddas om) för att undvika
    att variantväljaren och formatkorten kommer i otakt.
  - Händelsen "ks:format-change" skickas på document (för t.ex. avslutande köpblock och Extra bus).
  - Flytande köpknappen: på sidor med formatkort (och utan variantväljare) lägger den i varukorgen
    direkt – valt format – i stället för att bara skrolla upp till köpknappen.
*/
(() => {
  if (window.KsFormatPicker) return;

  const cache = new Map();

  function sectionUrl(productUrl, view, sectionId) {
    const u = new URL(productUrl, window.location.origin);
    if (view) u.searchParams.set('view', view);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function load(root, productUrl) {
    const key = productUrl + '|' + (root.dataset.view || '') + '|' + root.dataset.sectionId;
    if (!cache.has(key)) {
      const p = fetch(sectionUrl(productUrl, root.dataset.view, root.dataset.sectionId), { credentials: 'same-origin' })
        .then((r) => {
          if (!r.ok) throw new Error('KS Formatval: kunde inte hämta ' + productUrl);
          return r.text();
        })
        .then((html) => new DOMParser().parseFromString(html, 'text/html'))
        .catch((e) => {
          cache.delete(key);
          throw e;
        });
      cache.set(key, p);
    }
    return cache.get(key);
  }

  function importNode(node) {
    return document.importNode(node, true);
  }

  function swap(root, doc) {
    const sid = root.dataset.sectionId;
    const scope = document.getElementById('shopify-section-' + sid) || document;

    const outer = (sel) => {
      const cur = scope.querySelector(sel);
      const next = doc.querySelector(sel);
      if (cur && next) cur.replaceWith(importNode(next));
    };
    const inner = (sel) => {
      const cur = scope.querySelector(sel);
      const next = doc.querySelector(sel);
      if (cur && next) cur.innerHTML = next.innerHTML;
    };
    const attr = (sel, name) => {
      const cur = scope.querySelector(sel);
      const next = doc.querySelector(sel);
      if (!cur || !next) return;
      if (next.hasAttribute(name)) cur.setAttribute(name, next.getAttribute(name));
      else cur.removeAttribute(name);
    };

    // Pris, rubrik, produkttext
    outer('#price-' + CSS.escape(sid));
    inner('.wt-product__brand__name');
    inner('.wt-product__name');
    inner('#custom-desc-text');

    // Leveransrader (PDF/tryckt) och lagerrad
    attr('[data-ks-digital-usps]', 'hidden');
    attr('[data-ks-physical-usps]', 'hidden');
    inner('#stock-inventory-wrapper-' + CSS.escape(sid));

    // Köpknappen: rätt variant-ID, pris och läge
    const formSel = '#product-form-' + CSS.escape(sid);
    const curInput = scope.querySelector(formSel + ' [name="id"]');
    const nextInput = doc.querySelector(formSel + ' [name="id"]');
    if (curInput && nextInput) {
      const oldId = curInput.value;
      const newId = nextInput.value;
      // Alla formulär i sektionen som pekar på samma variant (köpknapp, delbetalning m.m.)
      scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach((input) => {
        if (input.value === oldId) {
          input.value = newId;
          input.setAttribute('value', newId);
        }
      });
    }
    const btnSel = '#ProductSubmitButton-' + CSS.escape(sid);
    inner(btnSel);
    attr(btnSel, 'disabled');
    attr(btnSel, 'aria-label');

    // Flytande köpknapp (bild, namn, pris)
    inner('.wt-product__sticky-buy__product');

    // Formatkorten
    const nextFp = doc.querySelector('[data-ks-fp]');
    if (nextFp) {
      const fresh = importNode(nextFp);
      root.replaceWith(fresh);
      enhance(fresh);
      const active = fresh.querySelector('.ks-fp__card.is-active');
      if (active) active.focus({ preventScroll: true });
      return fresh;
    }
    return root;
  }

  function mainLabel(sid) {
    const span = document.querySelector('#ProductSubmitButton-' + CSS.escape(sid) + ' .wt-btn__label span');
    return span ? span.textContent.trim() : '';
  }

  function upgradeSticky(root) {
    const sid = root.dataset.sectionId;
    const scope = document.getElementById('shopify-section-' + sid) || document;
    if (scope.querySelector('variant-options, variant-radios, variant-selects, .wt-product__option')) return;
    const sticky = scope.querySelector('sticky-buy-button') || document.querySelector('sticky-buy-button');
    if (!sticky) return;
    const btn = sticky.querySelector('button');
    if (!btn) return;
    const label = btn.querySelector(':scope > span');
    const text = mainLabel(sid);
    if (label && text) label.textContent = text;
    btn.setAttribute('aria-label', text || btn.getAttribute('aria-label') || '');
    if (sticky.dataset.ksUpgraded === 'true') return;
    sticky.dataset.ksUpgraded = 'true';
    sticky.addEventListener(
      'click',
      (e) => {
        const b = e.target.closest('button');
        if (!b || !sticky.contains(b)) return;
        const form = document.getElementById('product-form-' + sid);
        const main = document.getElementById('ProductSubmitButton-' + sid);
        if (!form || (main && main.disabled)) return;
        e.preventDefault();
        e.stopPropagation();
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      },
      true
    );
  }

  function newUrl(productUrl) {
    const u = new URL(productUrl, window.location.origin);
    const params = new URLSearchParams(window.location.search);
    params.delete('variant');
    params.delete('section_id');
    const q = params.toString();
    return u.pathname + (q ? '?' + q : '') + window.location.hash;
  }

  async function select(root, card) {
    const url = card.dataset.productUrl;
    if (!url || card.classList.contains('is-active') || card.classList.contains('is-disabled')) return;
    root.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');
    try {
      const doc = await load(root, url);
      const fresh = swap(root, doc);
      upgradeSticky(fresh);
      try {
        window.history.replaceState(window.history.state, '', newUrl(url));
      } catch (e) {}
      document.dispatchEvent(
        new CustomEvent('ks:format-change', {
          detail: {
            format: card.dataset.ksFormat,
            productId: card.dataset.productId,
            variantId: card.dataset.variantId,
            productUrl: url,
            root: fresh,
          },
        })
      );
    } catch (e) {
      console.warn(e);
      window.location.href = url;
    }
  }

  function prefetch(root) {
    root.querySelectorAll('.ks-fp__card[data-product-url]:not(.is-active):not(.is-disabled)').forEach((c) => {
      load(root, c.dataset.productUrl).catch(() => {});
    });
  }

  function enhance(root) {
    if (!root || root.dataset.ksFpReady === 'true') return;
    if (root.dataset.instant !== 'true' || !root.dataset.sectionId) return;
    // Mallar med temats variantväljare: korten förblir vanliga länkar (säkert läge)
    const section = document.getElementById('shopify-section-' + root.dataset.sectionId);
    if (section && section.querySelector('variant-options, variant-radios, variant-selects')) return;
    root.dataset.ksFpReady = 'true';

    const grid = root.querySelector('.ks-fp__grid');
    if (grid) grid.setAttribute('role', 'radiogroup');
    root.querySelectorAll('.ks-fp__card').forEach((card) => {
      const active = card.classList.contains('is-active');
      const disabled = card.classList.contains('is-disabled');
      card.setAttribute('role', 'radio');
      card.setAttribute('aria-checked', active ? 'true' : 'false');
      card.removeAttribute('aria-current');
      if (disabled) card.setAttribute('aria-disabled', 'true');
      if (!card.hasAttribute('href')) card.setAttribute('tabindex', active ? '0' : '-1');

      card.addEventListener('click', (e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        select(root, card);
      });
      card.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          select(root, card);
        }
      });
      const warm = () => card.dataset.productUrl && load(root, card.dataset.productUrl).catch(() => {});
      card.addEventListener('pointerenter', warm, { once: true });
      card.addEventListener('touchstart', warm, { once: true, passive: true });
      card.addEventListener('focus', warm, { once: true });
    });

    upgradeSticky(root);

    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500));
    idle(() => prefetch(root));
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ks-fp]').forEach(enhance);
  }

  window.KsFormatPicker = { init, select };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
